// extracted by mini-css-extract-plugin
export default {"table":"ByStatus_table__P8bNk","header":"ByStatus_header__egKdc","row":"ByStatus_row__PPvc2","status":"ByStatus_status__Hmhp0","dot":"ByStatus_dot__eDk8K"};